var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 76,
    viewBox: "0 0 53 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.744 35.4816V39.552H48.4768C48.016 56.9856 38.3392 71.1168 26.512 71.1168C14.3008 71.1168 4.47042 56.2944 4.47042 37.632C4.47042 19.0464 14.3008 4.14716 26.512 4.14716C32.7328 4.14716 38.5696 8.14076 43.2544 15.9744L46.7104 13.824C41.4112 4.99196 34.1152 0.0767574 26.512 0.0767574C12.1504 0.0767574 0.400024 17.1264 0.400024 37.632C0.400024 58.2144 12.1504 75.264 26.512 75.264C40.7968 75.264 52.5472 58.1376 52.5472 37.5552V35.4816H25.744Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperG);
export default __webpack_public_path__ + "static/media/UPPER_G.8e5be548e1cfa785ef21a94d6212593d.svg";
export { ForwardRef as ReactComponent };